import React from 'react';
export function SiteFooter() {
  return <footer className="w-full bg-forest-950 text-moss-200" data-id="element-280" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto flex max-w-content flex-col gap-3 px-5 py-7 sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-8 sm:py-10" data-id="element-281" data-mp="3r7zndkxykmaq">
        <p className="text-sm" data-id="element-282" data-mp="3mfg88jjmhj3t">© 2026 Varietyplus. Todos los derechos reservados.</p>
        <nav aria-label="Enlaces legales" className="flex flex-wrap gap-x-6 gap-y-2 text-sm" data-id="element-283" data-mp="3hi6bsjxtg76h">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-cream-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-moss-400" data-id="element-284" data-mp="3difm6jk0zx3j">
            Términos y condiciones
          </a>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-cream-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-moss-400" data-id="element-285" data-mp="2yl55mvsj010y">
            Política de privacidad
          </a>
        </nav>
      </div>
    </footer>;
}